import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { authApi } from '../axios';

export const useAdminCompanies = (plan) => useQuery({
  queryKey: ['super-admin', 'companies', plan ?? 'all'],
  queryFn: () => authApi.get('/v1/auth/admin/companies', { params: plan ? { plan } : {} }).then((r) => r.data),
  staleTime: 30000,
});

export const useAdminPlanRequests = (filters = {}) => useQuery({
  queryKey: ['super-admin', 'plan-requests', filters],
  queryFn: () => authApi.get('/v1/auth/admin/plan-requests', { params: filters }).then((r) => r.data),
  staleTime: 15000,
});

// Accepts either a plain request id (Pro requests — no extra terms) or
// { id, custom_plan_config } (Custom requests — Super Admin sets this
// company's own bespoke terms right at approval time, so every Custom
// customer can end up with different ones).
export const useApprovePlanRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (arg) => {
      const id = typeof arg === 'string' ? arg : arg.id;
      const custom_plan_config = typeof arg === 'string' ? undefined : arg.custom_plan_config;
      return authApi.patch(`/v1/auth/admin/plan-requests/${id}/approve`, custom_plan_config ? { custom_plan_config } : undefined).then((r) => r.data);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['super-admin'] }),
  });
};

export const useRejectPlanRequest = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reject_reason }) => authApi.patch(`/v1/auth/admin/plan-requests/${id}/reject`, { reject_reason }).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['super-admin'] }),
  });
};

// Edits an existing CUSTOM company's bespoke terms at any time (not just
// at approval) — e.g. from a "Custom Companies" management list.
export const useSetCustomPlan = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ companyId, ...terms }) => authApi.patch(`/v1/auth/admin/companies/${companyId}/custom-plan`, terms).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['super-admin'] }),
  });
};
